<app-nav titulo="Detalles del inquilino" descripcion="Aqui podrá ver toda la información que tenemos acerca del inquilino seleccionado.">
    <div class="tenant-details">
        <app-tenant-details-content [tenant]="tenant" [guaranties]="guaranties" *ngIf="tenant"></app-tenant-details-content>
    </div>
</app-nav>
